export default {
  nav: {
    auction: "Subasta Pública",
    ecosystem: "El Ecosistema",
    areas: "Áreas del Proyecto",
    naming: "Naming Rights & Alianzas",
    contact: "Contacto Privado",
    cta: "Solicitar Dossier Confidencial",
  },
  hero: {
    eyebrow: "Montalbán · Caracas · Venezuela",
    badge: "Fundación Deportiva Disimil",
    lines: [
      "El Nuevo Epicentro",
      "del Deporte, la Salud",
      "y la Formación",
      "Profesional en Caracas",
    ],
    subtitle:
      "Una alianza estratégica en Montalbán que transforma el territorio en un complejo de alto rendimiento, educación técnica superior y medicina preventiva.",
    ctaPrimary: "Oportunidades de Naming Rights",
    ctaSecondary: "Explorar las Áreas",
    scroll: "Desplácese",
  },
  marquee: [
    "Naming Rights Disponibles",
    "Montalbán · Caracas",
    "Centro de Alto Rendimiento",
    "Academia Deportiva Mcintosh",
    "Instituto de Estudios Superiores del Deporte",
    "Crioterapia & Hidroterapia",
    "Subasta Pública de Naming",
    "Fundación Deportiva Disimil",
  ],
  eco: {
    chapter: "01",
    label: "El Ecosistema",
    title: "Un ecosistema cuatripartito. Cuatro frentes de inversión.",
    subtitle:
      "Cuatro instituciones integradas bajo una sola gobernanza, cada una con oportunidades exclusivas de vinculación corporativa.",
    opportunityLabel: "Oportunidad de vinculación",
    cards: [
      {
        num: "01",
        category: "Infraestructura Atlética",
        title: "Centro de Alto Rendimiento Deportivo Montalbán",
        desc: "Campo principal de grama sintética, torres de iluminación LED nocturna, camerinos profesionales y gimnasio de alto rendimiento.",
        opportunity: "Naming Rights Principal del Complejo",
        badge: "Eje Deportivo",
        testid: "ecosystem-card-alto-rendimiento",
      },
      {
        num: "02",
        category: "Formación de Base",
        title: "Academia Deportiva Mcintosh",
        desc: "Cantera y formación deportiva integral para cientos de niños y jóvenes atletas de la comunidad.",
        opportunity: "Padrino de Cantera y Uniformes",
        badge: "Eje Formativo",
        testid: "ecosystem-card-mcintosh",
      },
      {
        num: "03",
        category: "Formación Académica",
        title: "Instituto de Estudios Superiores del Deporte Venezuela",
        desc: "Aulas inteligentes de certificación para entrenadores, árbitros y gerentes deportivos de todo el país.",
        opportunity: "Sponsor Académico Titular",
        badge: "Eje Educativo",
        testid: "ecosystem-card-instituto",
      },
      {
        num: "04",
        category: "Salud & Terapia",
        title: "Centro de Rehabilitación Deportivo Disimil",
        desc: "Consultorios médicos, salas de terapia física, fisioterapia avanzada y salas especializadas de crioterapia e hidroterapia.",
        opportunity:
          "Naming del Área de Salud — ideal para clínicas, aseguradoras y farmacéuticas",
        badge: "Eje Médico",
        testid: "ecosystem-card-rehabilitacion",
      },
    ],
  },
  trans: {
    chapter: "02",
    label: "Áreas del Proyecto",
    statement: "De un espacio en desuso a un ícono continental.",
    title: "El punto de partida: un territorio con historia, listo para renacer",
    subtitle:
      "Registro actual del complejo en Montalbán. Este material — capturado sobre el terreno — muestra la magnitud del espacio que el plan maestro transformará por fases.",
    videoLabel: "Registro audiovisual",
    videoCaption: "Así luce hoy el complejo — video registrado sobre el terreno, Montalbán",
    captions: [
      "Vista aérea del terreno — sector norte",
      "Vista aérea del terreno — sector sur",
      "Campo principal — estado actual",
      "Cancha de tierra — entrenamientos actuales",
    ],
    note: "Plan maestro por fases: recuperación del campo principal, torres LED, pabellón clínico y aulas del instituto. Las especificaciones técnicas se detallan en el Dossier Ejecutivo.",
  },
  plan: {
    chapter: "03",
    label: "Plan Maestro",
    title: "El plan maestro: así puede quedar el complejo",
    subtitle:
      "Plano conceptual original del proyecto. Nueve zonas planificadas sobre el terreno de Montalbán — cada una con naming individual disponible.",
    mapCaption: "Plano conceptual — diseño original del proyecto",
    zonesTitle: "Zonas del plan maestro",
    zones: [
      {
        name: "Cancha 1",
        desc: "Campo principal de grama sintética con torres de iluminación LED nocturna.",
      },
      {
        name: "Cancha 2",
        desc: "Segundo campo reglamentario para entrenamientos y torneos simultáneos.",
      },
      {
        name: "Centro de Estudios",
        desc: "Sede del Instituto de Estudios Superiores del Deporte Venezuela.",
      },
      {
        name: "Centro Terapéutico",
        desc: "Salas de fisioterapia, crioterapia e hidroterapia del Centro de Rehabilitación Disimil.",
      },
      {
        name: "Centro Médico",
        desc: "Consultorios médicos y atención deportiva especializada.",
      },
      {
        name: "Gimnasio",
        desc: "Gimnasio de alto rendimiento y preparación biomecánica.",
      },
      {
        name: "Oficinas",
        desc: "Sede administrativa de la Fundación Deportiva Disimil y la Mesa Técnica.",
      },
      {
        name: "Cafetín",
        desc: "Zona de esparcimiento y hospitalidad para atletas, familias y visitantes corporativos.",
      },
      {
        name: "Estacionamiento",
        desc: "Estacionamiento para atletas, personal médico y visitantes.",
      },
    ],
    note: "Cada zona admite naming individual, patrocinio de equipamiento o adopción completa por fase.",
  },
  naming: {
    chapter: "04",
    label: "Naming Rights & Alianzas",
    title: "Vincule el nombre de su marca a un legado histórico",
    subtitle:
      "Modelos de asociación institucional diseñados para maximizar el retorno reputacional. Sin cifras públicas: las condiciones se reservan para la mesa ejecutiva.",
    closing:
      "Las condiciones, especificaciones de retorno publicitario y pliegos técnicos se entregan de forma privada en reunión ejecutiva.",
    packages: [
      {
        badge: "Oportunidad Principal",
        title: "Naming Rights Titular del Complejo",
        framing: "Subasta pública · cierre 31 dic 2026",
        highlights: [
          "Derecho de bautizar todo el recinto: 'Complejo Deportivo [Su Marca]'",
          "Presencia monumental en fachada principal y círculo central del campo",
          "Marca en acreditaciones, transmisiones y papelería oficial",
          "Preferencia en eventos y giras de medios del complejo",
        ],
        cta: "Participar en la Subasta Confidencial",
        testid: "pkg-naming-titular",
      },
      {
        badge: "Sector Salud & Seguros",
        title: "Naming del Pabellón Clínico y Sala de Crioterapia",
        framing: "Ideal para clínicas, aseguradoras y farmacéuticas",
        highlights: [
          "Presencia de marca en el área médica de recuperación física",
          "Naming de salas de crioterapia e hidroterapia",
          "Visibilidad directa ante atletas y pacientes privados",
          "Convenios preferenciales de atención para ejecutivos aliados",
        ],
        cta: "Solicitar Dossier del Área de Salud",
        testid: "pkg-naming-clinico",
      },
      {
        badge: "Educación Corporativa",
        title: "Padrino Académico del Instituto",
        framing: "Liderazgo en formación deportiva nacional",
        highlights: [
          "Presencia de marca en aulas y laboratorios de certificación",
          "Marca en certificados técnicos oficiales emitidos por el instituto",
          "Programa de becas corporativas con el nombre de su organización",
          "Coorganización de congresos y jornadas técnicas",
        ],
        cta: "Agendar Presentación Académica",
        testid: "pkg-padrino-academico",
      },
      {
        badge: "Constructoras y Marcas",
        title: "Aliados Técnicos y Donaciones en Especie",
        framing: "Materiales de construcción y equipamiento",
        highlights: [
          "Acuerdos con empresas de construcción, iluminación, cableado, acero, cemento y pinturas",
          "Reconocimiento permanente como Aliado Constructor en placa de honor",
          "Certificación de aporte de Responsabilidad Social Empresarial",
          "Visibilidad en áreas técnicas durante la construcción y operación",
        ],
        cta: "Coordinar Aporte en Especie",
        testid: "pkg-aliados-tecnicos",
      },
    ],
  },
  auction: {
    "chapter": "05",
    "label": "Subasta Pública de Naming Rights",
    "title": "El nombre del complejo, en subasta pública",
    "subtitle": "Derechos de nombre titulares por 10 años. La empresa o persona con la mejor oferta al cierre bautizará el Centro de Alto Rendimiento Deportivo Montalbán.",
    "closesLabel": "Cierre de la subasta",
    "closesDate": "31 de diciembre de 2026 · 6:00 pm (hora de Venezuela)",
    "days": "Días",
    "hours": "Horas",
    "minutes": "Min",
    "seconds": "Seg",
    "leaderLabel": "Postor líder actual",
    "noBids": "Aún sin ofertas — sea el primero",
    "bidsLabel": "Ofertas recibidas",
    "biddersLabel": "Postores validados",
    "termLabel": "Vigencia",
    "termValue": "10 años",
    "rulesTitle": "Reglas de la subasta",
    "rules": [
      "Solo participan postores validados previamente por la Mesa Técnica.",
      "Los montos son confidenciales: solo los postores validados y la Mesa Técnica los conocen. El público ve únicamente el postor líder y el número de ofertas.",
      "Cada postor elige si aparece con su nombre/empresa o con un alias.",
      "Regla anti-cierre: toda oferta en los últimos 10 minutos extiende la subasta 10 minutos más.",
      "El ganador formaliza contrato con la Fundación y efectúa el aporte por transferencia bancaria, bajo auditoría internacional."
    ],
    "videoLabel": "Así lo hacen en el mundo",
    "videoTitle": "Estadios y arenas que llevan el nombre de una marca",
    "videoNote": "Allianz Arena, Emirates Stadium, Etihad Stadium, Mercedes-Benz Stadium, Estadio BBVA, Allianz Parque: marcas globales que convirtieron un recinto deportivo en su mayor vitrina. Montalbán abre esa misma oportunidad en Venezuela.",
    "ctaRegister": "Registrarme como Postor",
    "ctaEnter": "Entrar al Portal de Postores",
    "closed": "Subasta cerrada",
    "open": "Subasta abierta"
  },
  portal: {
    "back": "Volver al sitio",
    "title": "Portal de Postores",
    "subtitle": "Subasta Pública de Naming Rights · Complejo Montalbán",
    "login": "Iniciar sesión",
    "register": "Registrarme",
    "name": "Nombre completo",
    "company": "Empresa (opcional)",
    "email": "Correo electrónico",
    "phone": "Teléfono / WhatsApp",
    "password": "Contraseña (mín. 8 caracteres)",
    "displayMode": "¿Cómo desea aparecer públicamente?",
    "showName": "Mi nombre o empresa",
    "showAlias": "Un alias (Postor #NN)",
    "submitLogin": "Entrar",
    "submitRegister": "Enviar solicitud de registro",
    "logout": "Cerrar sesión",
    "pendingTitle": "Registro en validación",
    "pendingDesc": "La Mesa Técnica está verificando su solicitud. Recibirá un correo cuando su registro sea aprobado y pueda presentar ofertas.",
    "rejectedTitle": "Registro no aprobado",
    "rejectedDesc": "Su solicitud no fue validada. Si considera que se trata de un error, escríbanos desde el formulario de contacto.",
    "yourAlias": "Su identificador público",
    "highBid": "Oferta líder actual",
    "minNext": "Oferta mínima siguiente",
    "noHigh": "Sin ofertas aún",
    "leading": "Usted lidera la subasta",
    "outbid": "Su oferta ha sido superada",
    "notBid": "Aún no ha presentado ofertas",
    "bidLabel": "Su oferta (USD)",
    "placeBid": "Presentar oferta",
    "confirm": "¿Confirma su oferta de {amount} USD? Es vinculante.",
    "bidOk": "Oferta registrada",
    "extended": "La subasta se ha extendido por regla anti-cierre.",
    "history": "Historial de ofertas",
    "mine": "Usted",
    "closed": "La subasta ha cerrado. Gracias por participar.",
    "closesIn": "Cierra en",
    "welcome": "Bienvenido",
    "statusApproved": "Postor validado"
  },
  gov: {
    chapter: "06",
    label: "Gobernanza",
    title: "Gobernanza y transparencia de primer mundo",
    subtitle:
      "Cada aporte se administra bajo supervisión técnica, auditoría internacional y rendición de cuentas institucional.",
    features: [
      {
        title: "Fundación Deportiva Disimil",
        desc: "Entidad jurídica y rectora del proyecto: supervisión técnica y gestión institucional.",
      },
      {
        title: "Auditoría por ONG Internacional",
        desc: "Todos los fondos del proyecto serán auditados por una ONG internacional independiente, con rendición de cuentas periódica a los aliados.",
      },
      {
        title: "Mesa Técnica Ejecutiva",
        desc: "Ingenieros, médicos deportivos y gerentes de proyecto supervisan cada fase del plan maestro.",
      },
      {
        title: "Uso Exclusivo de Aportes",
        desc: "Cada contribución —en divisas o en especie— se destina exclusivamente al desarrollo y operación del complejo.",
      },
    ],
  },
  contrib: {
    chapter: "07",
    label: "Cómo Contribuir",
    title: "Canal oficial de contribución",
    subtitle: "Aportes directos, trazables y auditados. Sin intermediarios.",
    bankTitle: "Depósito o Transferencia Bancaria",
    bankDesc:
      "Las coordenadas bancarias oficiales en dólares (USD) se entregan junto al Dossier Ejecutivo Confidencial, una vez validada la solicitud de su organización.",
    bankFields: [
      "Banco corresponsal",
      "Titular: Fundación Deportiva Disimil",
      "Cuenta en dólares (USD)",
      "Referencia: Proyecto Complejo Montalbán",
    ],
    bankCta: "Solicitar Coordenadas Bancarias",
    kindTitle: "Donación en Especie",
    kindDesc:
      "Materiales de construcción, iluminación LED, acero, cemento, pinturas, grama sintética y equipamiento médico o deportivo.",
    kindCta: "Coordinar Donación en Especie",
    auditNote:
      "Todos los aportes —monetarios y en especie— son auditados por una ONG internacional y reportados a cada aliado.",
  },
  donate: {
    badge: "Pago seguro con tarjeta",
    title: "Donación con Tarjeta",
    desc: "Aporte directo, seguro y trazable en dólares. Procesado por Stripe, con certificación internacional de seguridad de pagos.",
    once: "Donación Única",
    monthly: "Aliado Mensual",
    monthlyHint: "Cargo recurrente cada mes. Puede cancelarse en cualquier momento.",
    amountLabel: "Seleccione un monto (USD)",
    custom: "Otro monto",
    customPlaceholder: "Monto en USD",
    nameLabel: "Nombre o empresa (opcional)",
    namePlaceholder: "Como desea aparecer en el Muro de Aliados",
    emailLabel: "Correo electrónico (para su recibo)",
    emailPlaceholder: "nombre@empresa.com",
    anonymous: "Deseo que mi donación sea anónima",
    anonymousHint: "Su nombre no se mostrará públicamente. El recibo se envía a su correo.",
    cta: "Donar con Tarjeta",
    ctaMonthly: "Convertirme en Aliado Mensual",
    redirecting: "Redirigiendo al pago seguro…",
    error: "No se pudo iniciar el pago. Intente nuevamente.",
    amountError: "Ingrese un monto válido entre 5 y 25.000 USD.",
    secure: "Cifrado SSL · Sus datos de tarjeta nunca pasan por nuestros servidores",
    wallLabel: "Muro de Aliados",
    wallTitle: "Quienes ya construyen Montalbán",
    wallEmpty: "Sea el primer nombre en este muro.",
    wallAnon: "aportes anónimos",
    wallMonthly: "Aliado Mensual",
    wallCorporate: "Empresas aliadas que ya aportaron",
    wallIndividual: "Aliados individuales",
    wallOnce: "Aliado",
  },
  payment: {
    checking: "Confirmando su aporte…",
    successTitle: "Gracias por construir Montalbán",
    successDesc: "Su aporte ha sido recibido y quedará registrado bajo auditoría internacional. Recibirá el comprobante en su correo electrónico.",
    successMonthly: "Bienvenido como Aliado Mensual del Complejo Montalbán.",
    pendingTitle: "Pago en proceso",
    pendingDesc: "Su banco está confirmando la operación. Le notificaremos por correo una vez completada.",
    failTitle: "No pudimos confirmar el pago",
    failDesc: "La sesión expiró o el pago no se completó. Puede intentarlo nuevamente.",
    cancelTitle: "Pago cancelado",
    cancelDesc: "No se realizó ningún cargo. Cuando lo desee, puede retomar su aporte.",
    back: "Volver al sitio",
    retry: "Intentar de nuevo",
  },
  contact: {
    chapter: "08",
    label: "Contacto Privado",
    title: "Agende una presentación con la Mesa Técnica",
    subtitle:
      "Toda solicitud es tratada bajo estricto acuerdo de confidencialidad. Respuesta ejecutiva garantizada.",
    name: "Nombre del Representante",
    company: "Empresa o Institución",
    email: "Correo Corporativo",
    phone: "Teléfono Directo / WhatsApp",
    interest: "Área de Interés",
    interestPlaceholder: "Seleccione un área",
    interests: [
      "Naming General del Complejo (Subasta)",
      "Área de Salud / Crioterapia",
      "Área Académica / Instituto",
      "Donación de Materiales de Construcción",
      "Alianza General / Otro",
    ],
    message: "Comentarios adicionales (opcional)",
    submit: "Agendar Presentación con la Mesa Técnica",
    submitting: "Enviando solicitud…",
    success:
      "Solicitud enviada con éxito. La Mesa Técnica se pondrá en contacto a la brevedad bajo acuerdo de confidencialidad.",
    error: "No se pudo enviar la solicitud. Inténtelo nuevamente.",
    privacy:
      "Su información se utiliza exclusivamente para la gestión de alianzas institucionales del proyecto.",
  },
  footer: {
    entity: "Fundación Deportiva Disimil",
    project: "Centro de Alto Rendimiento Deportivo Montalbán",
    location: "Montalbán, Municipio Libertador, Caracas, Venezuela",
    confidentiality:
      "Documentación reservada exclusivamente para aliados corporativos e institucionales.",
    navTitle: "Índice",
    masterplan: "Plan Maestro",
    governance: "Gobernanza",
    contribute: "Cómo Contribuir",
    rights: "© 2026 Fundación Deportiva Disimil. Todos los derechos reservados.",
  },
};
